export default "__VITE_ASSET__DEkroMc3__"